export default [
  {
    path: "/dashboard",
    name: "dashboard",
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "/bill/:CompanyID/TradeAccountList",
        name: "TradeAccountList",
        components: {
          default: (resolve) => require(["./TradeAccountList.vue"], resolve),
        },
      },
      {
        path: "/bill/:CompanyID/TradeAccountAdd",
        name: "TradeAccountAdd",
        components: {
          default: (resolve) => require(["./TradeAccountAdd.vue"], resolve),
        },
      },
      {
        path: "/bill/:CompanyID/TradeFlowList",
        name: "TradeFlowList",
        components: {
          default: (resolve) => require(["./TradeFlowList.vue"], resolve),
        },
      },
      // {
      //     path: '/bill/TradeDetail/:CompanyID/list',
      //     name: 'TradeDetailList',
      //     components: {
      //
      //         default: resolve => require(['./TradeDetail/list.vue'], resolve)
      //     }
      // },
      // {
      //     path: '/bill/TradeBill/:CompanyID/list',
      //     name: 'TradeBillList',
      //     components: {
      //
      //         default: resolve => require(['./TradeBill/list.vue'], resolve)
      //     }
      // },
      {
        path: "/bill/BankAccount/:CompanyID/list",
        name: "BankAccountList",
        components: {
          default: (resolve) => require(["./BankAccount/list.vue"], resolve),
        },
      },
      //   //应收账期
      //   {
      //     path: "/bill/BillReceive/:CompanyID/list",
      //     name: "BillReceiveList",
      //     components: {
      //       default: (resolve) => require(["./TradeBill/BillReceive/list.vue"], resolve),
      //     },
      //   },
      //应付账期
      {
        path: "/bill/BillPayment/:CompanyID/list",
        name: "BillPaymentList",
        components: {
          default: (resolve) => require(["./TradeBill/BillPayment/list.vue"], resolve),
        },
      },
      {
        path: "/bill/BillPayment/detail",
        name: "BillPaymentDetail",
        components: {
          default: (resolve) => require(["./TradeBill/BillPayment/detail.vue"], resolve),
        },
      },
      //交易应付
      {
        path: "/bill/TradeInfo/:CompanyID/TradePayment",
        name: "TradePayment",
        components: {
          default: (resolve) => require(["./TradeInfo/TradePayment.vue"], resolve),
        },
      },
      //   //交易应收
      //   {
      //     path: "/bill/TradeInfo/:CompanyID/TradeReceive",
      //     name: "TradeReceive",
      //     components: {
      //       default: (resolve) => require(["./TradeInfo/TradeReceive.vue"], resolve),
      //     },
      //   },
      //   //关账毛利合计
      //   {
      //     path: "/bill/BillStatistics/:CompanyID/ProfitStatistics",
      //     name: "ProfitStatistics",
      //     components: {
      //       default: (resolve) => require(["./BillStatistics/ProfitStatistics.vue"], resolve),
      //     },
      //   },
      //   //销量比较
      //   {
      //     path: "/bill/BillStatistics/:CompanyID/SalesComparison",
      //     name: "SalesComparison",
      //     components: {
      //       default: (resolve) => require(["./BillStatistics/SalesComparison.vue"], resolve),
      //     },
      //   },
      //   {
      //     path: "/bill/BillStatistics/:CompanyID/ClientStatistics",
      //     name: "ClientStatistics",
      //     components: {
      //       default: (resolve) => require(["../statistics/clientStatistics.vue"], resolve),
      //     },
      //   },
      {
        path: "/bill/company/tradedetails",
        components: {
          default: (resolve) => require(["./companytrade/details.vue"], resolve),
        },
      },
      {
        path: "/bill/bankcard/list",
        components: {
          default: (resolve) => require(["./bankcard/list.vue"], resolve),
        },
      },
      {
        path: "/bill/TradeStatistics/:CompanyID/list",
        name: "TradeStatisticsList",
        components: {
          default: (resolve) => require(["./TradeBill/TradeStatistics/list.vue"], resolve),
        },
      },
    ],
  },

  {
    path: "/fullscreen",
    name: "fullscreen",
    meta: {
      requiresAuth: true,
    },
    children: [
      //应收账期
      {
        path: "/bill/BillReceive/:CompanyID/list",
        name: "BillReceiveList",
        components: {
          default: (resolve) => require(["./TradeBill/BillReceive/list.vue"], resolve),
        },
      },
      //交易应收
      {
        path: "/bill/TradeInfo/:CompanyID/TradeReceive",
        name: "TradeReceive",
        components: {
          default: (resolve) => require(["./TradeInfo/TradeReceive.vue"], resolve),
        },
      },
      //关账毛利合计
      {
        path: "/bill/BillStatistics/:CompanyID/ProfitStatistics",
        name: "ProfitStatistics",
        components: {
          default: (resolve) => require(["./BillStatistics/ProfitStatistics.vue"], resolve),
        },
      },
      //销量比较
      {
        path: "/bill/BillStatistics/:CompanyID/SalesComparison",
        name: "SalesComparison",
        components: {
          default: (resolve) => require(["./BillStatistics/SalesComparison.vue"], resolve),
        },
      },
      {
        path: "/bill/BillStatistics/:CompanyID/ClientStatistics",
        name: "ClientStatistics",
        components: {
          default: (resolve) => require(["../statistics/clientStatistics.vue"], resolve),
        },
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/views/bill/router.js